module.exports = __webpack_public_path__ + "static/media/image-card-2.da9b4bbc.png";